import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "toggleComp"
}
const _hoisted_2 = { class: "customSetting" }
const _hoisted_3 = { class: "toggle" }
const _hoisted_4 = {
  class: "card bg-white mb-3",
  style: {"width":"100%","border-radius":"10px"}
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "inputs" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "Grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddCustomSetting = _resolveComponent("AddCustomSetting")!
  const _component_EditCustomSetting = _resolveComponent("EditCustomSetting")!
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_kendo_grid = _resolveComponent("kendo-grid")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_BModalOrchestrator = _resolveComponent("BModalOrchestrator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, {
      Heading: _ctx.customSettings,
      Title3: _ctx.Title,
      customSettingToggleValue: _ctx.customSettingToggleValue,
      customSettingFlag: true,
      defaultExpanded: _ctx.$route.query.expandSections === 'true'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.showCreatePopup)
            ? (_openBlock(), _createBlock(_component_AddCustomSetting, {
                key: 0,
                showCreatePopup: _ctx.showCreatePopup,
                duplicateCustomSettingId: _ctx.duplicateCustomSettingId,
                onVisibleDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreatePopup = false)),
                onGetCustomSettingId: _ctx.setNewCustomSetting,
                onGetCustomSettingsData: _ctx.loadGrid,
                onSave: _ctx.handleSave
              }, null, 8, ["showCreatePopup", "duplicateCustomSettingId", "onGetCustomSettingId", "onGetCustomSettingsData", "onSave"]))
            : _createCommentVNode("", true),
          (_ctx.showEditPopup)
            ? (_openBlock(), _createBlock(_component_EditCustomSetting, {
                key: 1,
                showEditPopup: _ctx.showEditPopup,
                customSettingId: _ctx.customSettingId,
                seamUnitDefaultValue: _ctx.seamUnitDefaultValue,
                seamLengthUnit: _ctx.seamLengthUnit,
                onVisibleEditDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditPopup = false)),
                onGetCustomSettingsData: _ctx.loadGrid,
                onEditSave: _ctx.handleEditSave
              }, null, 8, ["showEditPopup", "customSettingId", "seamUnitDefaultValue", "seamLengthUnit", "onGetCustomSettingsData", "onEditSave"]))
            : _createCommentVNode("", true),
          (+(_ctx.activeUserId ?? 0) == 101)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Title) + " :", 1),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_toggle_button, {
                    height: 25,
                    width: 60,
                    checkedText: "On",
                    uncheckedText: "Off",
                    checkedBg: " #0054a6",
                    uncheckedBg: "lightgrey",
                    modelValue: _ctx.toggleButtonVal,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toggleButtonVal) = $event)),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onToggleChange(_ctx.toggleButtonVal)))
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.showButtons)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-primary mb-3",
                    style: {"float":"right","border-radius":"4px","width":"11em","background-color":"#0054a6","color":"white"},
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showAddCustomSetting && _ctx.showAddCustomSetting(...args)))
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", {
                      class: "k-icon k-i-plus iconStyle",
                      style: {"margin-right":"5px"}
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.$t("customSetting.addNew")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.loadingGrid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("template", null, [
                        _createVNode(_component_GridLoading)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_kendo_grid, {
                        ref: "settingGrid",
                        "data-source": _ctx.dataSource,
                        columns: _ctx.columns,
                        sortable: true,
                        "column-menu": true,
                        filterable: true,
                        reorderable: true,
                        "scrollable-endless": true,
                        selectable: 'multiple',
                        persistSelection: true,
                        "selected-field": _ctx.selectedField
                      }, null, 8, ["data-source", "columns", "selected-field"])
                    ]))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["Heading", "Title3", "customSettingToggleValue", "defaultExpanded"]),
    _createVNode(_component_BModalOrchestrator)
  ], 64))
}